import { MIXPANEL_EVENT_ALLOWLIST, RED_FLAG_FIELDS } from "./allowlist";

const isPrimitive = (value) =>
  ["string", "number", "boolean"].includes(typeof value);

const sanitizeValue = (value) => {
  if (isPrimitive(value)) return value;
  if (Array.isArray(value)) {
    const filtered = value.filter(isPrimitive);
    return filtered.length ? filtered : undefined;
  }
  return undefined;
};

const hasRedFlagFields = (props) =>
  Object.keys(props || {}).some((key) => RED_FLAG_FIELDS.includes(key));

export const sanitizeMixpanelEvent = (eventName, props = {}) => {
  const allowlist = MIXPANEL_EVENT_ALLOWLIST[eventName];
  if (!allowlist) return null;
  if (hasRedFlagFields(props)) return null;

  const sanitized = {};
  allowlist.forEach((key) => {
    if (!(key in props)) return;
    const value = sanitizeValue(props[key]);
    if (value !== undefined) {
      sanitized[key] = value;
    }
  });

  return Object.keys(sanitized).length ? sanitized : null;
};
